import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private apiUrl = 'https://be.festivalsousse.com/api/auth';

  constructor(private http: HttpClient) { }

  login(username: string, password: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/login`, { username, password })
      .pipe(
        tap(reponse => {
          // Le jeton (JWT) est ce qui protege reellement les routes admin cote serveur -
          // il est renvoye a chaque requete via l'intercepteur HTTP (auth.interceptor.ts).
          if (reponse.success) {
            localStorage.setItem('admin_token', reponse.token);
            localStorage.setItem('admin_username', reponse.username);
          }
        })
      );
  }

  logout(): void {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_username');
  }

  estConnecte(): boolean {
    return !!localStorage.getItem('admin_token');
  }

  getToken(): string | null {
    return localStorage.getItem('admin_token');
  }

  getUsername(): string | null {
    return localStorage.getItem('admin_username');
  }

  changerMotDePasse(ancienMotDePasse: string, nouveauMotDePasse: string): Observable<any> {
    const username = this.getUsername() || 'admin';
    return this.http.post<any>(`${this.apiUrl}/changer-mot-de-passe`, {
      username, ancienMotDePasse, nouveauMotDePasse
    });
  }
}
